import React from 'react';
import { Layout } from '../components/Layout';
import { usePageMetadata } from '../hooks/usePageMetadata';

const TermsPage = () => {
  usePageMetadata();

  return (
    <Layout>
      <div className="bg-white min-h-screen py-16 px-4">
        <div className="max-w-4xl mx-auto prose prose-slate">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
          
          <p className="text-slate-500 mb-8">Last updated: February 2025</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">1. Acceptance of Terms</h2>
            <p className="text-slate-600">
              By accessing or using Stay Pair Homes ("Service"), you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">2. Description of Service</h2>
            <p className="text-slate-600">
              Stay Pair Homes is a platform that connects property owners with renters seeking mid-term housing 
              in Los Angeles County. We facilitate communication and transactions but are not a party to any 
              rental agreements between users.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">3. User Accounts</h2>
            <p className="text-slate-600">
              To use certain features, you must create an account. You agree to:
            </p>
            <ul className="list-disc list-inside text-slate-600 mt-2 space-y-1">
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">4. Property Owners</h2>
            <p className="text-slate-600">
              Property owners using our Service agree to:
            </p>
            <ul className="list-disc list-inside text-slate-600 mt-2 space-y-1">
              <li>Provide accurate listing information and photos</li>
              <li>Have legal authority to rent the property</li>
              <li>Comply with all applicable local, state, and federal laws</li>
              <li>Maintain appropriate insurance coverage</li>
              <li>Respond to inquiries and booking requests in a timely manner</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">5. Renters</h2>
            <p className="text-slate-600">
              Renters using our Service agree to:
            </p>
            <ul className="list-disc list-inside text-slate-600 mt-2 space-y-1">
              <li>Provide accurate personal information</li>
              <li>Respect property owners and their property</li>
              <li>Comply with house rules and rental agreements</li>
              <li>Make payments on time</li>
              <li>Report any issues or damages promptly</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">6. Payments</h2>
            <p className="text-slate-600">
              All payments are processed through our secure payment system. Property owners pay a monthly 
              subscription fee. Rental payments are transferred to owners after deducting any applicable fees. 
              Refunds are subject to each listing's cancellation policy.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">7. Prohibited Activities</h2>
            <p className="text-slate-600">
              Users may not:
            </p>
            <ul className="list-disc list-inside text-slate-600 mt-2 space-y-1">
              <li>Post false, misleading, or fraudulent content</li>
              <li>Harass, abuse, or discriminate against other users</li>
              <li>Circumvent our payment system</li>
              <li>Violate any laws or third-party rights</li>
              <li>Use the Service for any illegal purpose</li>
              <li>Scrape or collect data from the Service without permission</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">8. Disclaimer of Warranties</h2>
            <p className="text-slate-600">
              The Service is provided "as is" without warranties of any kind. We do not guarantee the accuracy 
              of listings, the conduct of users, or the outcome of any rental transaction.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">9. Limitation of Liability</h2>
            <p className="text-slate-600">
              Stay Pair Homes shall not be liable for any indirect, incidental, special, or consequential 
              damages arising from your use of the Service or any rental transaction.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">10. Modifications</h2>
            <p className="text-slate-600">
              We reserve the right to modify these Terms at any time. Continued use of the Service after 
              changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-900">11. Contact</h2>
            <p className="text-slate-600">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:support@staypairhomes.com" className="text-trust-blue hover:underline">
                support@staypairhomes.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;
